import { FormField } from '../types';
import { t } from './i18n';

export function validateField(field: FormField, value: any): string | null {
  // SECURITY: Sanitize input before validation
  // Trim and normalize string values
  if (typeof value === 'string') {
    value = value.trim();
  }
  
  // Required validation
  if (field.required && (!value || (typeof value === 'string' && value === ''))) {
    return t('validation.required', { label: field.label });
  }

  // Type-specific validation
  switch (field.componentType) {
    case 'email_input':
      if (value && !isValidEmail(value)) {
        return t('validation.email', { label: field.label });
      }
      break;

    case 'phone_input':
      if (value && !isValidPhone(value)) {
        return t('validation.phone', { label: field.label });
      }
      break;

    case 'number_input':
      if (value && isNaN(Number(value))) {
        return t('validation.number', { label: field.label });
      }
      break;

    case 'url_input':
      if (value && !isValidUrl(value)) {
        return t('validation.url', { label: field.label });
      }
      break;
  }

  // Custom validation from config
  // SECURITY: Validate type before checking length
  if (field.config?.minLength && value && typeof value === 'string' && value.length < field.config.minLength) {
    return t('validation.minLength', { label: field.label, min: field.config.minLength });
  }

  if (field.config?.maxLength && value && typeof value === 'string' && value.length > field.config.maxLength) {
    return t('validation.maxLength', { label: field.label, max: field.config.maxLength });
  }

  return null;
}

export function validateForm(fields: FormField[], formData: Record<string, any>): Record<string, string> {
  const errors: Record<string, string> = {};

  fields.forEach((field) => {
    const value = formData[field.fieldId];
    const error = validateField(field, value);
    if (error) {
      errors[field.fieldId] = error;
    }
  });

  return errors;
}

function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

function isValidPhone(phone: string): boolean {
  // Basic phone validation (allows +, numbers, spaces, dashes, parentheses)
  const phoneRegex = /^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{1,9}$/;
  return phoneRegex.test(phone.replace(/\s/g, ''));
}

function isValidUrl(url: string): boolean {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}
